import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { Input } from '@/components/ui/input';
import { Calendar } from '@/components/ui/calendar';
import dayjs, { Dayjs } from 'dayjs';
import { DatePickerFieldName } from '@/domain/termine/shared/types/datePicker';

type DatePickerFieldProps = {
  date?: Dayjs | undefined;
  onSelect: (date: Date) => void;
  icon?: IconDefinition;
  onChange?: () => void;
  name?: DatePickerFieldName;
};

function formatDate(date?: Date) {
  if (!date) return '';
  return dayjs(date).locale('de').format('dd., D. MMMM YYYY');
}

export default function DatePickerField({
  date,
  onSelect,
  icon,
  name,
}: DatePickerFieldProps) {
  const [open, setOpen] = useState(false);

  const selected =
    name === 'wiederholungBis' ? undefined : (date ?? dayjs()).toDate();

  const handleSelect = (d: Date) => {
    setOpen(false);
    onSelect(d);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <div className="flex flex-col justify-between">
          <Input
            endIcon={icon}
            className="cursor-pointer"
            value={formatDate(date?.toDate())}
            placeholder={'TT.MM.JJJJ YYYY'}
            readOnly
          />
        </div>
      </PopoverTrigger>
      <PopoverContent
        className="w-fit flex flex-col bg-white z-50"
        align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={handleSelect}
          defaultMonth={date?.toDate()}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
